module.exports = __webpack_public_path__ + "static/media/mediPangPang_textType_v1.1_103_9.f67beee9.svg";